import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.PricingLimitTemplate.Save.IRequest;
type Response = Api.Core.PricingLimitTemplate.Save.IResponse;
type Headers = Api.Core.PricingLimitTemplate.Save.IHeaders;
const url = '/api/ProductManagement/PricingLimitTemplate';
export default async function pricingLimitTemplateSaveApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: body?.id ? HttpMethod.put : HttpMethod.post,
    url,
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
